import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import { formatCurrency } from '../../../../F22/common/formatUtils';
import { TARJETAS_PERSONA } from '../cargadores';

const ESTADO_TEXTO = { validada: 'Validada', por_revisar: 'Por revisar' };

// Resumen de cada tarjeta: el dato principal que lleva al F22
const RESUMEN = {
  sueldos: (f) => `Renta neta ${formatCurrency(f.reduce((s, x) => s + (Number(x.renta_neta) || 0), 0))}`,
  intereses: (f) => `${f.length} institución(es)`,
  retiros: (f) => `${f.filter((x) => x.seccion === 'B').length} retiro(s)`,
  educacion: (f) => `${f.length} hijo(s)`,
};

/**
 * Datos de la persona que entran al F22: qué trae cada tarjeta del panel y en qué estado
 * está. Solo se usan las cargas validadas; para cambiar algo se vuelve al panel.
 */
const PersonaTarjetasSection = ({ data }) => {
  const persona = data.persona || { estados: {} };
  return (
    <SectionContainer title="Persona" subtitle="Datos de las tarjetas del panel que entran al F22">
      <div className="f22-subsection">
        <p className="f22-hint">
          Solo entran al F22 las cargas validadas. Para subir, validar o descartar un archivo, vuelve al panel.
        </p>
        <div className="f22-subtable">
          <div className="f22-subtable-header">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Tarjeta</div>
            <div className="f22-subtable-cell">Archivo</div>
            <div className="f22-subtable-cell">Estado</div>
            <div className="f22-subtable-cell" style={{ flex: 2 }}>Qué trae</div>
          </div>
          {TARJETAS_PERSONA.map((t) => {
            const estado = persona.estados?.[t.id];
            const filas = persona[t.id] || [];
            return (
              <div key={t.id} className="f22-subtable-row">
                <div className="f22-subtable-cell" style={{ flex: 3 }}>{t.titulo}</div>
                <div className="f22-subtable-cell">{t.fuente}</div>
                <div className="f22-subtable-cell">{ESTADO_TEXTO[estado] || 'Sin carga'}</div>
                <div className="f22-subtable-cell" style={{ flex: 2 }}>
                  {estado === 'validada' ? RESUMEN[t.id](filas) : 'No entra al cálculo'}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};

export default PersonaTarjetasSection;
